import { HTTP_STATUS_NO_CONTENT, HTTP_STATUS_INTERNAL_SERVER_ERROR } from '../../../helpers/validation/common';

export interface LoginHubResendConfirmationMailSuccessResponse {
	status: typeof HTTP_STATUS_NO_CONTENT;
}

export interface LoginHubResendConfirmationMailErrorResponse {
	status: typeof HTTP_STATUS_INTERNAL_SERVER_ERROR;
}

export type LoginHubResendConfirmationMailResponse =
	LoginHubResendConfirmationMailSuccessResponse |
	LoginHubResendConfirmationMailErrorResponse;

export type LoginHubResendConfirmationMailAction = () => Promise<LoginHubResendConfirmationMailResponse>;
